export enum FieldKind {
  Text = 'text',
  RichText = 'richText',
  DropDown = 'dropDown',
  ComboBox = 'comboBox',
  Date = 'date',
  CheckBox = 'checkBox',
}

export interface FieldOption {
  readonly value: string;
  readonly label: string;
}

export type FieldValue = string | boolean;

export interface DocField {
  readonly id: string;
  readonly kind: FieldKind;
  readonly label: string;
  readonly value: FieldValue;
  readonly placeholder: string;
  readonly options: readonly FieldOption[];
  readonly isPlaceholder: boolean;
  readonly multiline: boolean;
  /** Date pickers only: the template's own notation (w:dateFormat), e.g. "dd/MM/yyyy". */
  readonly dateFormat?: string;
}
